<template>
    <b-card>
        <b-card-header>
            {{ consolidationroute.name }}  
            <b-button size="sm" variant="secondary" title="Kod" @click="showCode()"><b-icon-code-square></b-icon-code-square> Kod</b-button>          
            <div v-if="IsChanged()"><b-button @click="SaveChanges()">Spara ändringar</b-button>&nbsp;<b-button @click="Cancel()">Avbryt</b-button></div>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col>
                    <label>Beskrivning:</label>
                    <b-textarea v-model="work.description" :readonly="readonly"></b-textarea>
                </b-col>
                <b-col>
                    <label>Behåll ursprungskollin</label>
                    <b-checkbox v-model="work.preventCleanup" :readonly="readonly"></b-checkbox>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-card v-for="(r, i) in GetSteps()" :key="i">
                        <b-card-header>
                            <b-button size="sm" title="Visa/dölj detaljer" variant="light" @click="ToggleStep(i)"><b-icon :icon="IsStepVisible(i) ? 'chevron-up' : 'chevron-down'"></b-icon></b-button>
                            Steg {{i+1}}: {{r.Description}}                             
                            <b-button variant="outline-secondary" v-if="!readonly" size="sm" @click="RemoveStep(r)" :title="'Ta bort steg'">
                                <b-icon-x-circle-fill></b-icon-x-circle-fill>
                            </b-button>
                            <b-button variant="outline-secondary" v-if="!readonly" size="sm" @click="DuplicateStep(r)" :title="'Duplicera steg'">
                                <b-icon-clipboard></b-icon-clipboard>
                            </b-button>
                            <b-button variant="outline-secondary" v-if="!readonly" size="sm" @click="MoveStep(r,-1)" :title="'Duplicera steg'">
                                <b-icon-caret-up></b-icon-caret-up>
                            </b-button>
                            <b-button variant="outline-secondary" v-if="!readonly" size="sm" @click="MoveStep(r,+1)" :title="'Duplicera steg'">
                                <b-icon-caret-down></b-icon-caret-down>
                            </b-button>
                        </b-card-header>
                        <b-card-body v-if="IsStepVisible(i)">
                            <div >
                                <consolidationroutestep v-bind:value="r" @input="onstepinput($event, i)" :readonly="readonly" :basics="basics">
                                </consolidationroutestep>
                               
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button v-if="!readonly" @click="AddStep()">Lägg till steg</b-button>
                </b-col>
            </b-row>
            <b-modal v-model="jsonvisible" size="xl" ok-only :no-close-on-backdrop="true"
      v-bind:no-close-on-esc="true" :title="Json">      
                <b-button v-if="jsonlocked&&!readonly" variant="secondary-outline" @click="setJsonEditorEditstate(true)"><b-icon-lock></b-icon-lock>&nbsp;Låst</b-button>
                <!-- <b-button v-if="!jsonlocked" variant="danger" @click="setJsonEditorEditstate(false)"><b-icon-unlock></b-icon-unlock>&nbsp;Upplåst</b-button> -->
                <b-button v-if="!jsonlocked&&!readonly" variant="danger" @click="applyCode()"><b-icon-code></b-icon-code>&nbsp;Applicera kod</b-button>
                <b-button v-if="!jsonlocked&&!readonly" variant="danger" @click="pasteFromClipBoard()"><b-icon-code></b-icon-code>&nbsp;Klistra in</b-button>
                          
                <v-jsoneditor v-if="work" v-model="jsonwork" :options="options"
                                :plus="true" :height="'640px'" @error="onError"></v-jsoneditor>
            </b-modal>
        </b-card-body>
    </b-card>
</template>
<script>
// import datepicker from "../../components/datepicker";
import consolidationroutestep from "./../consolidationroute/consolidationroutestep.vue";
import VJsoneditor from 'v-jsoneditor/src/index';

import { Api } from "../../lib/api";
const api = new Api();


export default {
    name: 'consolidationroutedetails',
    components: { consolidationroutestep,VJsoneditor },
    props: {
        consolidationroute: Object,
        readonly: Boolean,        
    },
    data() {
        return {
            work: null,
            jsonwork: null,
            origCopy: null,
            basics: null,
            visiblesteps: [],
            options: {
                "mode": "code",
                "search": true,
                onEditable:  (path, field, value)=> false,
            },
            jsonvisible: false,
            jsonlocked:true,
        }
    },
    watch: {
        consolidationroute: function () {
            this.Init();
        },
    },
    created() {
        if (this.consolidationroute)
            this.Init();
    },
    methods: {
        Init() {            
            this.visiblesteps=[];
            this.work = JSON.parse(JSON.stringify(this.consolidationroute));
            this.origCopy = JSON.stringify(this.consolidationroute);  
            if(!this.basics)
                api.get('/api/consolidationroute/getbasics').then((res) => {
                    this.basics = res.data;
                });
        },
        IsStepVisible(idx) {
            return this.visiblesteps[idx]==true;
        },
        ToggleStep(idx) {
            this.visiblesteps[idx]=!this.visiblesteps[idx];
            this.$forceUpdate();
        },
        GetSteps() {
            return this.work.steps;
        },
        onstepinput(s, i) {
            this.work.steps[i] = s;
        },
        IsChanged() {
            return JSON.stringify(this.work) !== this.origCopy;
        },
        AddStep() {
            this.work.steps.push({filter: '*'});
            this.visiblesteps[this.work.steps.length-1]=true;
        },
        RemoveStep(r) {
            var idx = this.work.steps.findIndex(x => x === r);
            if(idx>=0) {
                this.work.steps.splice(idx,1);
                this.visiblesteps.splice(idx,1);
                this.$forceUpdate();
            }            
        },
        DuplicateStep(r) {
            var idx = this.work.steps.findIndex(x => x === r);
            if(idx>=0) {
                var newo = JSON.parse(JSON.stringify(r));
                this.work.steps.splice(idx,0,newo);
                this.visiblesteps.splice(idx,0,newo);
                this.$forceUpdate();
                //this.work = JSON.parse(JSON.stringify(r)); //Trigger change
            }
        },
        MoveStep(r,jump) {
            var idx = this.work.steps.findIndex(x => x === r);
            if(idx>=0) {
                
                var newIdx = idx+jump;
                if(newIdx<0)
                    newIdx = 0;
                if(newIdx>this.work.steps.length-1)
                    newIdx = this.work.steps.length-1; //-1?
                //Swap
                this.work.steps[idx] = this.work.steps[newIdx];
                this.work.steps[newIdx]=r;

                var rVis = this.visiblesteps[idx];
                var t2Vis = this.visiblesteps[newIdx];
                this.visiblesteps[idx]=t2Vis;
                this.visiblesteps[newIdx]=rVis;
                
                this.$forceUpdate();
            }

        }
        ,
        SaveChanges() {
            if(confirm("OBS! Detta kan påverka funktionen. Vill du verkligen spara ändringar?")) {
                var p = {Name: this.work.name, RouteDefinitionJson: JSON.stringify(this.work)};
                api.post('/api/consolidationroute/AddOrUpdate', p).then(res => {
                    if(res.data) {
                        alert(res.data);
                        return;
                    }
                    this.origCopy = JSON.stringify(this.work);
                    this.$emit('changed', this.work);
                });                
            }
        },
        Cancel() {
            this.$emit('cancelled');
            this.Init();
        },
        OnError() {
            alert();
        },
          setJsonEditorEditstate(editable) {
            this.jsonlocked = !editable;
            if(editable)
                this.options.onEditable = ()=> true;
            else
                this.options.onEditable = ()=> false;
            
        },
        onEditable (path, field, value) {
            return !this.jsonlocked;
        },
        showCode() {
            this.jsonwork = JSON.parse(JSON.stringify(this.work));
            this.jsonvisible = true;
        },
        pasteFromClipBoard() {
            navigator.clipboard
            .readText()
            .then((clipText) => {
                console.log(clipText);
                try {
                    var objFromCb = JSON.parse(clipText);
                    console.log(objFromCb);
                    this.jsonwork =objFromCb;
                } catch (error) {
                    alert(`Gick inte att klistra in: ${error}:\n${clipText}`);
                    return;
                }

                // this.jsonvisible=false;
                // this.jsonlocked=true;
                this.$forceUpdate();
            });
        },
        applyCode() {
            if(!this.jsonwork) {
                alert('Koden verkar inte vara korrekt. Vänligen kontrollera.');
                return;
            }
            if(confirm('Vill du ersätta flödet med din kod?')) {
                this.work = JSON.parse(JSON.stringify(this.jsonwork));
                this.jsonvisible = false;
                this.jsonwork = null;
                this.$forceUpdate();
            }
        }
    }
}

</script>